import { useMemo } from "react";

import { useAttachments } from "../../../../../reactQuery/boards";
import {
  getResponseData,
  getTotalRecord,
} from "../../../../../reactQuery/response";

export function useBoardAttachmentsList(boardId) {
  const { attachments, isLoading, isError, refetch } = useAttachments(boardId);

  const attachmentItems = useMemo(
    () => getResponseData(attachments, []),
    [attachments]
  );
  const totalRecord = useMemo(
    () => getTotalRecord(attachments),
    [attachments]
  );

  return {
    attachmentItems,
    hasAttachments: totalRecord > 0,
    isError,
    isLoading,
    refetch,
    totalRecord,
  };
}
